import { render, staticRenderFns } from "./ShopInfoChange.vue?vue&type=template&id=16cb581c&scoped=true"
import script from "./ShopInfoChange.vue?vue&type=script&lang=ts"
export * from "./ShopInfoChange.vue?vue&type=script&lang=ts"
import style0 from "./ShopInfoChange.vue?vue&type=style&index=0&id=16cb581c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb581c",
  null
  
)

export default component.exports